import { render, staticRenderFns } from "./HotStatistics.vue?vue&type=template&id=5a5f4952&scoped=true"
import script from "./HotStatistics.vue?vue&type=script&lang=js"
export * from "./HotStatistics.vue?vue&type=script&lang=js"
import style0 from "./HotStatistics.vue?vue&type=style&index=0&id=5a5f4952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f4952",
  null
  
)

export default component.exports